import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { motion, AnimatePresence } from 'framer-motion';
import FormFocus from '../utils/FormFocus';
import { StyledAlert, StyledFormControl, StyledHelperText, StyledInputLabel } from './FormControl.styled';
function FormControl(_ref) {
  var disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    helperText = _ref.helperText,
    helperTextPlacement = _ref.helperTextPlacement,
    label = _ref.label,
    hideLabel = _ref.hideLabel,
    required = _ref.required,
    showError = _ref.showError,
    errorMessage = _ref.errorMessage,
    children = _ref.children,
    edges = _ref.edges,
    name = _ref.name;
  return /*#__PURE__*/React.createElement(StyledFormControl, {
    fullWidth: fullWidth,
    disabled: disabled
  }, label && !hideLabel && /*#__PURE__*/React.createElement(StyledInputLabel, {
    shrink: true,
    htmlFor: name,
    sx: {
      marginBottom: !!helperText && helperTextPlacement === 'above' ? 0 : 1
    },
    required: required
  }, label), helperText && /*#__PURE__*/React.createElement(StyledHelperText, {
    sx: {
      order: helperTextPlacement === 'below' ? 1 : null,
      marginTop: helperTextPlacement === 'below' ? 1 : 0
    }
  }, /*#__PURE__*/React.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  }), " ", helperText), children || /*#__PURE__*/React.createElement(FormFocus, {
    name: name
  }), /*#__PURE__*/React.createElement(AnimatePresence, null, showError && /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      translateY: -20,
      opacity: 0
    },
    animate: {
      translateY: 0,
      opacity: 1
    },
    exit: {
      translateY: -20,
      opacity: 0
    },
    transition: {
      duration: 0.25,
      ease: 'easeOut'
    }
  }, /*#__PURE__*/React.createElement(StyledAlert, {
    severity: "error",
    edges: edges
  }, errorMessage))));
}
FormControl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @ign
   */
  children: PropTypes.any,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Whether or not to display an error message (if there is a message to display).
   */
  showError: PropTypes.bool,
  /**
   * The error message to display if showError === true
   */
  errorMessage: PropTypes.string,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * Placed the helper text above or below the input.
   */
  helperTextPlacement: PropTypes.oneOf(['above', 'below']),
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * Make label visible only to screen readers
   */
  hideLabel: PropTypes.bool,
  /**
   * The input name.
   */
  name: PropTypes.string.isRequired,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp'])
} : {};
FormControl.defaultProps = {
  children: null,
  disabled: false,
  fullWidth: false,
  hideLabel: false,
  helperText: '',
  helperTextPlacement: 'above',
  label: '',
  required: false,
  showError: false,
  errorMessage: '',
  edges: 'normal'
};
export default FormControl;